import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReportingUiModule } from '@ot/reporting/ui';
import { SharedDirectivesModule } from '@ot/shared/directives';
import { AutocompleteComponent } from './question-components/autocomplete/autocomplete.component';
import { DatepickerQuestionComponent } from './question-components/datepicker-question/datepicker-question.component';
import { DropdownQuestionComponent } from './question-components/dropdown-question/dropdown-question.component';
import { FiniteListMultiselectQuestionComponent } from './question-components/finite-list-multiselect-question/finite-list-multiselect-question.component';
import { MultiselectComponent } from './question-components/multiselect/multiselect.component';
import { SearchMultiselectQuestionComponent } from './question-components/search-multiselect-question/search-multiselect-question.component';
import { SwitchQuestionComponent } from './question-components/switch-question/switch-question.component';
import { TextareaQuestionComponent } from './question-components/textarea-question/textarea-question.component';
import { TextboxQuestionComponent } from './question-components/textbox-question/textbox-question.component';
import { RadioQuestionComponent } from './question-components/radio-question/radio-question.component';

@NgModule({
  declarations: [
    AutocompleteComponent,
    DatepickerQuestionComponent,
    DropdownQuestionComponent,
    FiniteListMultiselectQuestionComponent,
    MultiselectComponent,
    SearchMultiselectQuestionComponent,
    SwitchQuestionComponent,
    TextareaQuestionComponent,
    TextboxQuestionComponent,
    RadioQuestionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReportingUiModule,
    SharedDirectivesModule
  ],
  exports: [
    AutocompleteComponent,
    DatepickerQuestionComponent,
    DropdownQuestionComponent,
    FiniteListMultiselectQuestionComponent,
    MultiselectComponent,
    SearchMultiselectQuestionComponent,
    SwitchQuestionComponent,
    TextareaQuestionComponent,
    TextboxQuestionComponent,
    RadioQuestionComponent
  ],
  providers: []
})
export class SharedQuestionsModule {}
